import React from 'react';
import {Link} from 'react-router-dom';
import AddBoxIcon from '@material-ui/icons/AddBox';
import {withStyles} from '@material-ui/core/styles';
import {Button} from 'react-admin';

const styles = {
  button: {
    marginTop: '1em'
  }
};

const AddFormItemButton = ({classes, record, context}) => {
  let to = `/form_items/create?context=${context}&${context}=${record['@id']}`;
  if (record['@type'] === "FormStep") {
    to = `/form_items/create?context=${context}&${context}=${record['@id']}&form=${record['form']}`;
  }
  return (
    <Button
      className={classes.button}
      variant="text"
      component={Link}
      to={to}
      label="Add a form item"
      title="Add a form item"
    >
      <AddBoxIcon/>
    </Button>
  )
};

export default withStyles(styles)(AddFormItemButton);
